import { useTranslation } from 'react-i18next';
import { Alert, CircularProgress } from '@mui/material';

import { searchSelectionBlockNoticeKey, type SearchResultGenerationAuthority } from '../searchResultAuthority';

export function SearchResultGenerationStatus({ authority }: { authority: SearchResultGenerationAuthority }) {
  const { t } = useTranslation();
  // Vencido y divergido bloquean la selección por motivos distintos, pero el
  // asesor lee UN cartel: el que explica lo que acaba de pasar. Qué gana lo
  // decide `searchSelectionBlock`, la misma función que elige el motivo que va
  // pegado al botón bloqueado.
  const noticeKey = searchSelectionBlockNoticeKey(authority);

  return (
    <>
      {authority.isRefreshingStaleGeneration && (
        <Alert severity="info" icon={<CircularProgress color="inherit" size={18} />}>
          {t('travelServices.refreshingPrices')}
        </Alert>
      )}
      {noticeKey && <Alert severity="warning">{t(noticeKey)}</Alert>}
    </>
  );
}
